export const Footer = () => (
  <footer className="bg-[#1f281e] text-[#faf8f5] py-16 border-t border-[#2d4a22]/40" data-testid="footer">
    <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
      <div>
        <a href="/" data-testid="footer-logo" aria-label="Sahagun Landscape — home">
          <img src="/images/logo.png" alt="Sahagun Landscape" className="h-16 w-auto mb-3" />
        </a>
        <p className="text-xs text-[#a4d19b] font-mono-type" data-testid="footer-address">
          15306 Castana Ave, Paramount CA 90723
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 text-xs uppercase tracking-widest text-[#d3e4d0]">
        <a href="#services" data-testid="footer-services" className="hover:text-white transition-colors">Services</a>
        <a href="#work" data-testid="footer-projects" className="hover:text-white transition-colors">Projects</a>
        <a href="#reviews" data-testid="footer-reviews" className="hover:text-white transition-colors">Reviews</a>
        <a href="/about" data-testid="footer-about-page" className="hover:text-white transition-colors">About Us</a>
        <a href="/careers" data-testid="footer-careers" className="hover:text-white transition-colors">Careers</a>
        <a href="#about" data-testid="footer-about" className="hover:text-white transition-colors">About</a>
        <a href="#contact" data-testid="footer-estimate" className="hover:text-white transition-colors">Free Estimate</a>
        <a
          href="https://www.instagram.com/sahagungroup"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="inline-flex items-center gap-2 hover:text-white transition-colors"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
          </svg>
          Instagram
        </a>
      </div>

      <div className="text-xs text-[#a4d19b]">
        <span data-testid="footer-specialist">Sales Specialist: Juan Sahagun</span>
      </div>
    </div>
  </footer>
);
